import { EmailPreviewFrame } from '@/components/tiptap/EmailPreviewFrame'

interface TemplatePreviewProps {
    subject: string
    html: string
}

export const TemplatePreview = ({ subject, html }: TemplatePreviewProps) => (
    <div className="flex flex-col gap-2">
        <div className="rounded-xl bg-surface-secondary px-3 py-2">
            <span className="text-[11px] font-semibold uppercase tracking-wider text-foreground-muted">Subject</span>
            <p className="mt-0.5 text-sm text-foreground">{subject || 'No subject'}</p>
        </div>
        <EmailPreviewFrame title="Email template preview" html={html} className="h-[360px] w-full rounded-2xl bg-surface shadow-field" />
        <p className="text-xs text-foreground-muted">Preview is sandboxed and cannot execute scripts, open forms, or affect the application.</p>
    </div>
)
